const dataOffer = [
  {
    offer: 'SAT',
    children: [
      {
        paragraph:
          'Vous pouvez bénéficier d’une aide <b>jusqu’à 300&nbsp;€&nbsp;TTC</b>, sous la forme d’une <b>remise immédiate</b>.',
        subtitle: 'Deux façons d’utiliser la subvention :',
        block01: true,
        block01Title:
          'Je choisis l’acquisition du kit, et ça ne me coûte rien.',
        block01column01: true,
        block01column01Text:
          '<div class="heading-01">0&nbsp;€ <small>au lieu de 299&nbsp;€</small></div>',
        block01columnMentions:
          'Après déduction de l’aide de l’État, aucun frais à avancer.',
        block02: true,
        block02Title:
          'Je choisis la location du kit, alors le Service Pose ne me coûte rien.',
        block02column01: true,
        block02column01Text:
          '<div class="heading-04">Kit Satellite</div><div class="heading-01">8&nbsp;€/&nbsp;mois</div>',
        block02column02: true,
        block02column02Text:
          '<div class="heading-04">Service Pose</div><div class="heading-01">0&nbsp;€ <small>au lieu de 299&nbsp;€</small></div>',
        block02columnMentions:
          'Après déduction de l’aide de l’État, aucun frais à avancer.',
      },
    ],
  },
  {
    offer: 'SAT_PRO',
    children: [
      {
        paragraph:
          'Vous pouvez bénéficier d’une aide de <b>99&nbsp;€&nbsp;HT</b> (118,80&nbsp;€&nbsp;TTC), sous la forme d’<b>une remise immédiate</b>',
        subtitle: null,
        block01: true,
        block01Title: 'Frais de mise en service',
        block01column01: true,
        block01column01Text:
          '<div class="heading-01">0&nbsp;€ <small>au lieu de 99&nbsp;€&nbsp;HT</small></div>',
        block01columnMentions:
          'Après déduction de l’aide de l’État, aucun frais à avancer.',
        block02: false,
      },
    ],
  },
  {
    offer: '4G_FIX',
    children: [
      {
        paragraph:
          'Vous pouvez bénéficier d’une aide <b>jusqu’à 300&nbsp;€&nbsp;TTC</b>, sous la forme d’une <b>remise immédiate</b>.',
        subtitle: 'Deux façons d’utiliser la subvention&nbsp;:',
        block01: true,
        block01Title:
          'Je choisis l’acquisition du routeur, et ça ne me coûte rien.',
        block01column01: true,
        block01column01Text:
          '<div class="heading-01">0&nbsp;€ <small>au lieu de 199&nbsp;€</small></div>',
        block01columnMentions:
          'Après déduction de l’aide de l’État, aucun frais à avancer.',
        block02: true,
        block02Title:
          'Je choisis la location du routeur&nbsp;: le Service Pose ne me coûte rien.',
        block02column01: true,
        block02column01Text:
          '<div class="heading-04">Routeur Extérieur 4G</div><div class="heading-01">8&nbsp;€/&nbsp;mois</div>',
        block02column02: true,
        block02column02Text:
          '<div class="heading-04">Service Pose</div><div class="heading-01">0&nbsp;€ <small>au lieu de 249&nbsp;€</small></div>',
        block02columnMentions:
          'Après déduction de l’aide de l’État, aucun frais à avancer.',
      },
    ],
  },
];

export default dataOffer;
